<wsb-modal
  disabledFooter="true"
  (close)="activeModal.close()"
  (dismiss)="activeModal.dismiss()"
  [primaryButtonEnable]="false"
  title="{{ 'sms_template_new' | translate }}"
>
  <div body>
    <p class="warning-text">{{'sms_templates_alert' | translate}}</p>
    <div class="">
      <div class="shadow-top"></div>

      <div *ngIf="filteredTemplates.length" class="sms-template-list flex-wrap">
        <div *ngFor="let template of filteredTemplates" class="card text-center m-3">
          <div class="card-body">
            <h5 class="card-title">{{ template.name | truncate: 20:'...' }}</h5>

            <p class="card-text">
              {{ template.text | truncate: 100:'...' }}
            </p>
            <div class="card-footer">
              <wsb-atlas-button (btnClick)="activeModal.close(template)" class="use-button" variant="primary" label="common_use" size="lg"></wsb-atlas-button>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="!filteredTemplates.length" class="m-5">{{'sms_templates_empty_alert' | translate}}</div>
    </div>
    <div class="shadow-bottom"></div>

    <div footer class="modal-footer" style="display: flex; justify-content: flex-start;">
      <wsb-atlas-button class="send-sms-button1" variant="primary" label="sms_templates_new" size="lg" (btnClick)="createNewTemplate()"></wsb-atlas-button>
    </div>
  </div>
</wsb-modal>
